import { Reservation } from "./reservation"
import { DocumentSnapshot, Timestamp, logger } from "../firestoreImports"

interface PermanentReservationParameters {
    underlyingReservation: Reservation
    validFrom?: Date | null
    validTo?: Date | null
    routeId?: string | null
}

export class PermanentReservation {
    underlyingReservation: Reservation
    validFrom?: Date | null
    validTo?: Date | null
    routeId?: string | null

    constructor(parameters: PermanentReservationParameters) {
        this.underlyingReservation = parameters.underlyingReservation
        this.validFrom = parameters.validFrom
        this.validTo = parameters.validTo
        this.routeId = parameters.routeId
    }

    static fromData(doc: DocumentSnapshot): PermanentReservation | null {
        if (!doc.data()) {
            logger.warn(`Cannot create PermanentReservation ${doc.id} from snapshot`)
            return null
        }
        const reservation = Reservation.fromData(doc)
        if (!reservation) {
            return null
        }
        if (!reservation.canceled) {
            reservation.confirmed = true
            reservation.status = reservation.reservationStatus()
        }
        const data = doc.data()!
        const validFrom = (data.validFrom as Timestamp | undefined)?.toDate() ?? reservation.timestampCreated
        const validTo = (data.validTo as Timestamp | undefined)?.toDate()
        const routeId = (data.routeId as string | undefined) ?? undefined

        return new PermanentReservation({
            underlyingReservation: reservation,
            validFrom: validFrom,
            validTo: validTo,
            routeId: routeId
        })
    }

    isValid = () => {
        if (this.underlyingReservation.canceled) {
            return false
        }
        if (this.validFrom && this.validFrom.getTime() > Date.now()) {
            return false
        }
        if (this.validTo && this.validTo.getTime() < Date.now()) {
            return false
        }
        return true
    }

    asData(): Record<string, unknown> {
        return {
            ...this.underlyingReservation.asData(),
            validFrom: this.validFrom ? Timestamp.fromDate(this.validFrom) : undefined,
            validTo: this.validTo ? Timestamp.fromDate(this.validTo) : undefined,
            routeId: this.routeId ?? undefined
        }
    }
}
